import styled from 'styled-components'
import { adjustHue, lighten } from 'polished'
import Avatar from 'static/images/activity_course_master_course_avatar.svg'

export default styled.div`
  width: 100%;
  height: 75px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 20px 20px 0 0;
  background: url(${Avatar}),
    linear-gradient(
      to top,
      ${props => lighten(0.12, `#${props.courseColor}`)},
      ${props => adjustHue(350, lighten(0.22, `#${props.courseColor}`))}
    );

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-blend-mode: overlay;
`
